export const convertOnPress = (
  onPress?: (event: unknown) => void
): (() => void) => {
  return () => {
    if (typeof onPress === 'function') {
      onPress(undefined);
    }
  };
};
